import React, { useEffect, useState } from 'react';
import logoamerisa from '../assets/logoamerisa.png';

const WmsTopbar = ({ 
  showSearch = true, 
  title = '', 
  onSearchChange = () => {}, 
  searchValue = '',
  rightContent = null,
  warehouseName
}) => {
  // Si no se pasa warehouseName, lo toma del localStorage
  const [almacen, setAlmacen] = useState(warehouseName || '');
  useEffect(() => {
    if (!warehouseName) {
      try {
        const wmsWarehouse = JSON.parse(localStorage.getItem('wms_warehouse'));
        setAlmacen(wmsWarehouse?.warehousename || 'Sin almacén asignado');
      } catch {
        setAlmacen('Sin almacén asignado');
      }
    } else {
      setAlmacen(warehouseName);
    }
  }, [warehouseName]);

  return (
    <div className="bg-sky-900 text-white p-4 flex items-center justify-between relative">
      <div className="flex items-center">
        {/* Botón menú hamburguesa a la izquierda en móviles */}
        {rightContent && (
          <span className="md:hidden mr-2">{rightContent}</span>
        )}
        <img src={logoamerisa} alt="Logo" className="h-8" />
        {title && <h1 className="ml-4 text-xl font-semibold">{title}</h1>}
      </div>
      
      <div className="flex items-center">
       {/* {showSearch && (
          <div className="relative max-w-sm w-full mr-4">
            <input
              type="text"
              placeholder="Buscar..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full p-2 pl-10 bg-white border rounded-md text-sm text-gray-700"
            />
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
              🔍
            </span>
          </div>
        )}*/}
        
        <div className="flex items-center">
          <span className="mr-4 text-sm">
            Estás trabajando en: <span className="font-semibold">{almacen}</span>
          </span>
          {rightContent && <span className="hidden md:inline">{rightContent}</span>}
        </div>
      </div>
    </div>
  );
};

export default WmsTopbar;
